export function euroFormat(num: any, floor?: boolean): string {
  if (typeof num == "string") {
    let n = floor ? parseFloat(num) : (Math.ceil(parseFloat(num)*100)/100)
    let r = n.toLocaleString('de-DE', 
      { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
    return r === "NaN" ? "0,00" : r 
  }
  if (typeof num == "number") {
    let n = floor ? num : (Math.ceil(num*100)/100)
    let r = n.toLocaleString('de-DE', 
      { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    return r === "NaN" ? "0,00" : r
  }
  return "0,00"
}

export function euroFeesFormat(num: any): string {
  if (typeof num == "string") {
    return (Math.ceil(parseFloat(num)*100)/100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }
  if (typeof num == "number") {
    return (Math.ceil(num*100)/100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }
  return ""
}

export function convertCurrency(curr: string): string {
    if(curr === 'EUR') return '€';
    else if(curr === 'USD') return '$';
    else return ""
}

function formatQuantity(num: any, maxFraction: number): string {
  if (num === null || num === undefined) return '0';

  let numericValue: number;
  let minFraction = 0;

  if (typeof num === 'number') {
    numericValue = num;
    if (!Number.isFinite(numericValue)) return '0';

    // Detect fractional digits for numbers
    if (!Number.isInteger(numericValue)) {
      const m = String(numericValue).match(/^-?\d+\.(\d+)$/);
      if (m) minFraction = Math.min(m[1].length, maxFraction);
    }
  } else if (typeof num === 'string') {
    let str = num.trim();
    if (str === '') return '0';

    // Remove leading non-digits (e.g., "@3994" → "3994")
    str = str.replace(/^[^\d+-]+/, '');

    const lastComma = str.lastIndexOf(',');
    const lastDot = str.lastIndexOf('.');
    let origFractionDigits = 0;

    if (str.includes(',') && str.includes('.')) {
      if (lastComma > lastDot) {
        // Comma is decimal, dots are thousand separators
        origFractionDigits = str.length - lastComma - 1;
        str = str.replace(/\./g, '').replace(',', '.');
      } else {
        // Dot is decimal, commas are thousand separators
        origFractionDigits = str.length - lastDot - 1;
        str = str.replace(/,/g, '');
      }
    } else if (str.includes(',')) {
      origFractionDigits = str.length - str.lastIndexOf(',') - 1;
      str = str.replace(/\./g, '').replace(',', '.');
    } else if (str.includes('.')) {
      origFractionDigits = str.length - str.lastIndexOf('.') - 1;
      str = str.replace(/,/g, '');
    }

    numericValue = parseFloat(str);
    if (isNaN(numericValue) || !Number.isFinite(numericValue)) return '0';

    // Preserve decimals if <= maxFraction
    minFraction = origFractionDigits > 0 && origFractionDigits <= maxFraction ? origFractionDigits : 0;
  } else {
    return '0';
  }

  if (minFraction > maxFraction) minFraction = 0;

  return numericValue.toLocaleString('de-DE', {
    minimumFractionDigits: minFraction,
    maximumFractionDigits: maxFraction,
  });
}

// Original 5-decimal function
export function quantityFormat(num: any): string {
  return formatQuantity(num, 5);
}

// New 2-decimal function
export function euroQtyFormat(num: any): string {
  return formatQuantity(num, 2);
}

export function checkRegexEmail(email: string) {
  let reg_exp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (reg_exp.test(email)) return true;
  else return false;
}

export function addTimezoneOffset(isoDate: string, offset: number): Date {
  if(offset) {
    var targetTime = new Date(isoDate);
    var tzDifference = offset * 60 + targetTime.getTimezoneOffset();
    var newDate = new Date(targetTime.getTime() + tzDifference * 60 * 1000);
    return newDate
  }
  return new Date(isoDate)
}

export function removeTimezoneOffset(isoDate: string, offset: number): Date {
  if(offset) {
    var targetTime = new Date(isoDate);
    var tzDifference = offset * 60 + targetTime.getTimezoneOffset();
    var newDate = new Date(targetTime.getTime() - tzDifference * 60 * 1000);
    return newDate
  }
  return new Date(isoDate)
}

export function formatDate(isoDate: string, offset: number){
  const date = addTimezoneOffset(isoDate, offset);
  date.setDate(date.getDate())
  return date.toLocaleDateString("en-US")
}

export function convertToSimpleDate(isoDate: string){
  let date = new Date(isoDate)
  return date.toLocaleDateString("en-US")
}

export function formatDatetime(isoDate: any){
  const date = new Date(isoDate);
  date.setDate(date.getDate())
  return date.toLocaleDateString("en-US") + " " + date.toLocaleTimeString()
}

export function formatDatetimeOffset(isoDate: any, offset: number){
  const date = addTimezoneOffset(isoDate, offset);
  date.setDate(date.getDate())
  return date.toLocaleDateString("en-US") + " " + date.toLocaleTimeString()
}

export function formatExpiringDate(isoDate: any, offset: number){
  const date = addTimezoneOffset(isoDate, offset);
  date.setDate(date.getDate() + 30)
  return date.toLocaleDateString("en-US")
}

export function getProfileUrl(basicAccountState : any, detailAccountState: any): string {
  if(basicAccountState.payload && basicAccountState.payload.kyc_submitted)
      return "/profile"
  else if(detailAccountState.payload && detailAccountState.payload.last_name && detailAccountState.payload.last_name?.length > 0) {
      return "/account/almost-done"
  }       
  return "/account/additional-info"
}


/*    FORM VALIDATION UTILS    */

export function formValidationClearErrors(){
  var elems = document.querySelectorAll(".error")
    elems.forEach(el=> {
        el.classList.remove("error");
    });
}

function isInvalidDate(d: any) {
  return (d instanceof Date) && isNaN(d.getTime())
}

export function formValidationCheckObject(obj: any, type?: string){
  let count = 0
  Object.entries(obj).forEach(([key, value]) => {
      var camelCased = key.replace(/_([a-z])/g, function (g) { return g[1].toUpperCase(); });
      
      if(value === '' //|| value === "1999-10-15T00:00:00Z"  why this check???
        || isInvalidDate(value) || 
        /*(key === "market_value" && value === 0) || */
        (key === "year" && value === 0) ){ 
        
        
        if(key === 'investment_period'){
          camelCased = type === "overview" ? "overviewInvestmentPeriod" : "fundTermsInvestmentPeriod"
        }
        
        if(document && document.getElementById(camelCased)){
          document.getElementById(camelCased)!.classList.add('error')
          count ++
        }
      }

      if(typeof value === "object" && key === "odometer"){
        let tmp:any = value  
        if(tmp?.odometer_unit === ""){
          if(document && document.getElementById("odometerUnit")){
            document.getElementById("odometerUnit")!.classList.add('error')
            count ++
          }
        }
      }
  })
  return count
}

export function formValidationCheckObjectTokenization(obj: any, type?: string){
  let count = 0
  Object.entries(obj).forEach(([key, value]) => {
      var camelCased = key.replace(/_([a-z])/g, function (g) { return g[1].toUpperCase(); });
      if(value === '' || 
        (key === "total_supply" && value === 0) || 
        (key === "proposed_price" && value === 0) ||
        (key === "pct_tokenized" && value === 0)){ 

            if(document && document.getElementById(camelCased)){
              document.getElementById(camelCased)!.classList.add('error')
              count ++
          }
      }
  })
  return count
}

export function isValidHttpUrl(string: string) {
  let url;
  try {
    if(string.trim().length < 1) return false
    if(!string.includes("//")) return false
    url = new URL(string);
  } catch (_) { 
    return false;
  }
  if(url.protocol !== "http:" && url.protocol !== "https:") return false
  if(!url.host) return false
  
  const hostname = url.hostname;

  // Allow IPv4
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) return true;

  // Allow IPv6 inside brackets
  if (/^\[.*\]$/.test(hostname)) return true;

  // Require at least one dot for normal domains
  return hostname.includes(".");
}

export function sanitizeInputField(text: string): string {
  if (!text) return "";

  return text
    // 1. Remove control characters (C0/C1), but preserve \r and \n for now
    .replace(/[\x00-\x09\x0B-\x0C\x0E-\x1F\x7F-\x9F]/g, "")
    // 2. Remove BMP private-use area (Co)
    .replace(/[\uE000-\uF8FF]/g, "")
    // 3. Remove specific known unassigned chars used in tests
    .replace(/\u0378/g, "")
    // 4a. Normalize CRLF or LFCR to \n
    .replace(/\r\n|\n\r/g, "\n")
    // 4b. Normalize any remaining CR, LS, PS to \n
    .replace(/\r|\u2028|\u2029/g, "\n")
    // 5. Replace all Unicode spaces with a normal space
    .replace(/[\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000]/g, " ")
    // 6. Collapse multiple spaces into one
    .replace(/ +/g, " ")
    // 7. Trim only leading/trailing whitespace
    .replace(/^\s+|\s+$/g, "");
}

